import React, { useEffect, useState, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Eye } from 'lucide-react';
const MIN = 5;
const MAX = 25;
const randInt = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
export const ViewersCounter = () => {
  const [count, setCount] = useState(() => randInt(8, 16));
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const scheduleNext = (updater: () => void) => {
    // 8-15 seconds, with occasional pauses (up to ~22s)
    const shouldPause = Math.random() < 0.18;
    const delay = shouldPause ? randInt(16000, 22000) : randInt(8000, 15000);
    timeoutRef.current = setTimeout(() => {
      updater();
    }, delay);
  };
  useEffect(() => {
    const tick = () => {
      setCount(prev => {
        // step magnitude: mostly ±1, sometimes ±2
        const magnitude = Math.random() < 0.8 ? 1 : 2;
        // direction: slight bias toward staying within mid range
        const drift = prev > 18 ? -1 : prev < 9 ? 1 : Math.random() < 0.5 ? -1 : 1;
        let next = prev + drift * magnitude;
        if (next < MIN) next = MIN + randInt(0, 1);
        if (next > MAX) next = MAX - randInt(0, 1);
        return next;
      });
      scheduleNext(tick);
    };
    scheduleNext(tick);
    // Slight bump on user interaction (scroll/click)
    let bumpCooldown = false;
    const handleInteraction = () => {
      if (bumpCooldown) return;
      bumpCooldown = true;
      setTimeout(() => bumpCooldown = false, 12000);
      setCount(prev => {
        if (prev >= MAX - 1) return prev;
        return Math.random() < 0.6 ? prev + 1 : prev;
      });
    };
    window.addEventListener('scroll', handleInteraction, {
      passive: true
    });
    window.addEventListener('click', handleInteraction);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      window.removeEventListener('scroll', handleInteraction);
      window.removeEventListener('click', handleInteraction);
    };
  }, []);
  return <div className="inline-flex items-center gap-2.5 text-sm text-zinc-400 bg-dark-900/60 border border-white/5 py-2 px-4 rounded-full" data-id="element-204">
      <span className="relative flex h-2 w-2 shrink-0" data-id="element-205">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-500/60 opacity-75" data-id="element-206"></span>
        <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-207"></span>
      </span>
      <Eye className="w-4 h-4 text-zinc-500" aria-hidden="true" data-id="element-208" />
      <span className="leading-none" data-id="element-209">
        <AnimatePresence mode="popLayout" initial={false} data-id="element-210">
          <motion.span key={count} initial={{
          y: 6,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} exit={{
          y: -6,
          opacity: 0
        }} transition={{
          duration: 0.25,
          ease: 'easeOut'
        }} className="inline-block font-semibold text-white tabular-nums" data-id="element-211">
            {count}
          </motion.span>
        </AnimatePresence>{' '}
        personas están viendo esta página ahora mismo
      </span>
    </div>;
};